import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ListSubheader from "@material-ui/core/ListSubheader";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import SearchIcon from "@material-ui/icons/Search";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import Avatar from "@material-ui/core/Avatar";
import { handleOptionSetValue } from "../../../../../../../../Utils/Helpers/optionSet.helper";
import { ListItemSecondaryAction } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    maxWidth: 420,
    background: "var(--color-background-paper)",
    color: "var(--color-text-primary)",
    position: "fixed",
    overflow: "auto",
    maxHeight: "84vh",
    borderRadius: "12px",
    top: "70px",
    right: "10%",
    zIndex: "99999",
    border: "1px solid rgba(0,0,0,0.08)",
    boxShadow: "0 8px 32px rgba(0,0,0,0.12)",
    [theme.breakpoints.down("sm")]: {
      minWidth: "100vw",
      width: "100%",
      maxWidth: "100%",
      borderRadius: 0,
      overflow: "auto",
      maxHeight: "93vh",
      top: "65px",
      right: "0%",
      position: "fixed",
      border: "none",
    },
  },
  ul: {
    backgroundColor: "inherit",
    padding: 0,
  },
  crmSubheader: {
    background: "var(--search-subheader-bg)",
    color: "var(--color-text-primary)",
    fontWeight: "bold",
    textTransform: "capitalize",
    fontSize: "0.72rem",
    letterSpacing: "0.05em",
    lineHeight: "2",
  },
  crmHeader: {
    background: "var(--color-background-default)",
    borderBottom: "1px solid var(--search-subheader-bg)",
    cursor: "pointer",
    transition: "background 0.15s ease, box-shadow 0.15s ease",
    "&:hover": {
      background: "var(--search-item-hover-bg)",
      boxShadow: "inset 3px 0 0 var(--color-primary-main)",
    },
    "& > div": {
      minWidth: "30px",
      color: "var(--color-primary-main)",
    },
    "& > span": {
      fontSize: "12px",
      color: "var(--color-text-secondary)",
      "& > b": {
        fontSize: "14px",
        marginRight: "8px",
        color: "var(--color-text-primary)",
      },
    },
  },
  crmListItem: {
    background: "var(--color-background-paper)",
    cursor: "pointer",
    transition: "background 0.15s ease, box-shadow 0.15s ease",
    "&:hover": {
      background: "var(--search-item-hover-bg)",
      boxShadow: "inset 3px 0 0 var(--color-primary-main)",
      "& $listItemPrimary": {
        color: "var(--color-primary-main)",
      },
      "& .MuiAvatar-root": {
        boxShadow: "0 0 0 2px var(--color-primary-main)",
      },
    },
  },
  listItemPrimary: {
    color: "var(--color-text-primary)",
    fontSize: "0.875rem",
    fontWeight: 500,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    transition: "color 0.15s ease",
  },
  listItemSecondary: {
    color: "var(--color-text-secondary)",
    fontSize: "0.75rem",
  },
  divider: {
    margin: 0,
    border: "none",
    borderTop: "1px solid var(--search-subheader-bg)",
  },
  showMoreBtn: {
    display: "flex",
    justifyContent: "flex-end",
    fontSize: "13px",
    marginRight: "10px",
    textDecoration: "underline",
    color: "var(--color-primary-main)",
    cursor: "pointer",
  },
  chips: {
    backgroundColor: "var(--sidebar-background)",
    color: "var(--sidebar-fontcolor)",
    fontSize: "0.6rem",
    padding: "0.2rem 0.4rem",
    borderRadius: "0.2rem",
    fontWeight: 600,
    whiteSpace: "nowrap",
  },
  actionItem: {
    maxWidth: "30%",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "end",
    gap: "0.2rem",
  },
  emptyState: {
    padding: "16px",
    color: "var(--color-text-secondary)",
    fontSize: "0.875rem",
    "& b": {
      color: "var(--color-text-primary)",
      marginRight: "4px",
    },
  },
}));

const M_ScrollView = (props) => {
  const classes = useStyles();
  const {
    allCrmResult,
    setIsFullPage,
    searchKey,
    handleClick,
    isLoading,
    setSearchLimit,
  } = props;
  return (
    <Box className={classes.root} id="SearchScrollView">
      {allCrmResult.length > 0 ? (
        <List disablePadding>
          <ListItem
            button
            className={classes.crmHeader}
            onClick={() => setIsFullPage(true)}
          >
            <ListItemIcon>
              <SearchIcon />
            </ListItemIcon>
            <span>
              <b>{searchKey}</b>&nbsp;Click here to view all results
            </span>
          </ListItem>
          {allCrmResult.map((item) => (
            <li key={item.crmRecordType}>
              <ul className={classes.ul}>
                <ListSubheader disableSticky className={classes.crmSubheader}>
                  {item.crmRecordType}
                </ListSubheader>
                {item.crmRecordDetails
                  .slice(0, setSearchLimit)
                  .map((list, index, dataSet) => {
                    const { id, email, title, link, chips } = list;
                    return [
                      <ListItem
                        key={id}
                        onClick={() => handleClick(list)}
                        className={classes.crmListItem}
                      >
                        <ListItemAvatar style={{ minWidth: "44px" }}>
                          <Avatar alt={title} src={link} style={{ width: 34, height: 34 }} />
                        </ListItemAvatar>
                        <ListItemText
                          primary={title}
                          secondary={handleOptionSetValue(email)}
                          primaryTypographyProps={{ className: classes.listItemPrimary }}
                          secondaryTypographyProps={{
                            className: classes.listItemSecondary,
                            style: {
                              overflowWrap: "break-word",
                              maxWidth: chips.length > 0 ? "80%" : "100%",
                            },
                          }}
                          style={{
                            maxWidth: chips.length > 0 ? "70%" : "100%",
                          }}
                        />
                        {chips.length > 0 && (
                          <ListItemSecondaryAction className={classes.actionItem}>
                            {chips
                              .filter((chip) => chip !== "" && chip != null)
                              .map((chip) => (
                                <span className={classes.chips} key={chip.toString()}>
                                  {chip.toString()}
                                </span>
                              ))}
                          </ListItemSecondaryAction>
                        )}
                      </ListItem>,
                      index < dataSet.length - 1 ? (
                        <hr key={`divider-${id}`} className={classes.divider} />
                      ) : null,
                    ];
                  })}
              </ul>
            </li>
          ))}
        </List>
      ) : (
        <ListItem className={classes.emptyState}>
          {isLoading ? (
            <span>Searching...</span>
          ) : (
            <span>
              <b>{searchKey}</b>No results found
            </span>
          )}
        </ListItem>
      )}
    </Box>
  );
};

M_ScrollView.propTypes = {
  allCrmResult: PropTypes.array,
  setIsFullPage: PropTypes.bool,
  searchKey: PropTypes.string,
  handleClick: PropTypes.func,
  isLoading: PropTypes.bool,
  setSearchLimit: PropTypes.string,
};

export default M_ScrollView;
